import { render, staticRenderFns } from "./AdminUpload.vue?vue&type=template&id=5b4c397a&scoped=true&"
import script from "./AdminUpload.vue?vue&type=script&lang=js&"
export * from "./AdminUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c397a",
  null
  
)

export default component.exports